import { ApiService } from "./api.service";
import type { ILmsConnectPayload, TLmsConnection, TLmsConnectionDetail } from "@/types/lms";

/** The LMS connection endpoints (plan §6.2 / §6.8).
 *
 *  Connect and test both make live vendor calls server-side and sit in the 2–10s
 *  response-time band, so every caller of those two owns a visible progress
 *  indicator. The lifecycle verbs are single-row writes and return promptly.
 */
export class LmsConnectionService extends ApiService {
  async listConnections(slug: string): Promise<TLmsConnection[]> {
    return this.get(`/api/workspaces/${slug}/lms-connections/`);
  }

  async connect(slug: string, payload: ILmsConnectPayload): Promise<TLmsConnectionDetail> {
    return this.post(`/api/workspaces/${slug}/lms-connections/`, payload);
  }

  async testConnection(slug: string, connectionId: string): Promise<TLmsConnectionDetail> {
    return this.post(`/api/workspaces/${slug}/lms-connections/${connectionId}/test/`);
  }

  async pause(slug: string, connectionId: string): Promise<TLmsConnection> {
    return this.post(`/api/workspaces/${slug}/lms-connections/${connectionId}/pause/`);
  }

  async resume(slug: string, connectionId: string): Promise<TLmsConnection> {
    return this.post(`/api/workspaces/${slug}/lms-connections/${connectionId}/resume/`);
  }

  async disconnect(slug: string, connectionId: string): Promise<TLmsConnection> {
    return this.post(`/api/workspaces/${slug}/lms-connections/${connectionId}/disconnect/`);
  }
}
